import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ENDPOINT,CLIENT_CANVAS_WIDTH,CLIENT_CANVAS_HEIGHT } from "constants/variables";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import SignatureCanvas from "react-signature-canvas";
import PropTypes from "prop-types";
import "css/generalSettings.css";
import "css/customDialog.css";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from "reducers/loadingSlice";
import { LoadingNews } from "components/utils/LoadingNews";
import { successErrorAction, warningErrorAction } from "actions/ErrorActions";
import ReportPurchaseSignature from "pages/purchaseSignature/purchaseSignatureSign/ReportPurchaseSignature";
 
const SQUARE_SIZE = CLIENT_CANVAS_HEIGHT;
 

const initialState = {
  id : "",
  defaultStore_id:0, 
  tradename: "",
  useraccount_id:0,
  username: "",
  defaultformatnumber:1,
  isfinished:false, 
  purchasenote:0, 
  numberticket:0, 
  ownnumberpurchase:"", 
  datepurchase: null, 

  vehiclestore_id: 0,
  vehiclestore_licenseplate: "",
  vehiclestore_defaultdriver: "",
  vehiclestore_store_id: 0,

  rel_trans_store_id: 0,
  rel_trans_documnettype_id: 0,
  rel_trans_documentid: "",
  rel_trans_documnettype_name: "",
  rel_trans_tradename: "",
  rel_trans_name: "",
  rel_trans_contacperson: "",
  rel_trans_nima: "",
  rel_trans_pygr: "",
  rel_trans_grnp:"",
  rel_trans_opt: 0,
  rel_trans_roadtype_id: 0,
  rel_trans_street: "",
  rel_trans_country_id: 1,
  rel_trans_province_id: 30,
  rel_trans_postalcode_id: 0,

  ori_tras_store_id: 0,
  ori_tras_documnettype_id: 0,
  ori_tras_documnettype_name: "",
  ori_tras_documentid: "",
  ori_tras_tradename: "",
  ori_tras_name: "",
  ori_tras_contacperson: "",
  ori_tras_nima: "",
  ori_tras_pygr: "",
  ori_tras_grnp:"",
  ori_tras_opt: 0,
  ori_tras_workplace: "",
  ori_tras_roadtype_id: 0,
  ori_tras_street: "",
  ori_tras_country_id: 1,
  ori_tras_province_id: 30,
  ori_tras_postalcode_id: 0,
  ori_tras_email: "",

  observations: "",
  totalpurchasedelivery: 0,
  totaldiscountpurchasedelivery: 0,
  totaltaxespurchasedelivery:0,
  totalNetoPurchasedelivery:0,
  enabled:true,
  subownnumberpurchase:0,
  payment_id : 0 ,
  payment_code: "",
  payment_namees: "",
  payment_nameen: "",
  totalWeigthNeto:0,
  signature_dispatched_by:"",
  signature_client:"",
  linespurchasedelivery:[]
}; 

const PurchaseDeliverySign = ({ id, showModalPurchasesSignatureSettings }) => {
  const { t } = useTranslation(["listDataPurchases"]);
  const token = useSelector((state) => state.loginUser.token);
  const isLoading = useSelector((state) => state.loading.isLoading);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState(initialState);
  const [pdfBlob, setPdfBlob] = useState(null);
  const canvasRef = useRef(null);

  const pdfUrl = useMemo(() => {
    if (!pdfBlob) return "";
    return URL.createObjectURL(pdfBlob);
  }, [pdfBlob]);

  useEffect(() => {
    return () => {
      if (pdfUrl) URL.revokeObjectURL(pdfUrl);
    };
  }, [pdfUrl]);

  useEffect(() => {
    if (!canvasRef.current) return;
    const canvas = canvasRef.current.getCanvas();
    canvas.width = CLIENT_CANVAS_WIDTH;
    canvas.height = CLIENT_CANVAS_HEIGHT;
  }, []);

  const drawSignatureCentered = useCallback((base64) => {
    if (!canvasRef.current || !base64) return;
    const canvas = canvasRef.current.getCanvas();
    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, CLIENT_CANVAS_WIDTH, CLIENT_CANVAS_HEIGHT);
    const img = new Image();
    img.src = base64;
    img.onload = () => {
      const squareX = (CLIENT_CANVAS_WIDTH - SQUARE_SIZE) / 2;
      const squareY = (CLIENT_CANVAS_HEIGHT - SQUARE_SIZE) / 2;
      const scale = Math.min(
        SQUARE_SIZE / img.width,
        SQUARE_SIZE / img.height
      );
      const drawWidth = img.width * scale;
      const drawHeight = img.height * scale;
      const x = squareX + (SQUARE_SIZE - drawWidth) / 2;
      const y = squareY + (SQUARE_SIZE - drawHeight) / 2;
      ctx.drawImage(img, x, y, drawWidth, drawHeight);
      const trimmed = canvasRef.current
        .getTrimmedCanvas()
        .toDataURL("image/png");
      setFormData((prev) => ({
        ...prev,
        signature_client: trimmed
      }));
    };
  }, []);

  const handleSaveSignature = () => {
    if (!canvasRef.current) return;

    const base64 = canvasRef.current
      .getTrimmedCanvas()
      .toDataURL("image/png");

    drawSignatureCentered(base64);
  };

  const handleDeleteSignature = () => {
    if (!canvasRef.current) return;
    canvasRef.current.clear();

    setFormData((prev) => ({
      ...prev,
      signature_client: ""
    }));
  };

  const handleClose = useCallback(() => {
    setFormData(initialState);
    setPdfBlob(null);
    dispatch(setLoading(false));
    navigate("/purchasesignature");
  }, [dispatch, navigate]);

  useEffect(() => {
    if (!showModalPurchasesSignatureSettings) return;
    let mounted = true;
    const fetchData = async () => {
      dispatch(setLoading(true));
      try {
        const res = await helpHttp().get2(
          ENDPOINT,
          "purchasesignature/getpurchasesignaturebyid/",
          token,
          id
        );
        if (!mounted) return;
        if (!res.err) {
          setFormData(res);
          if (res.signature_client) {
            drawSignatureCentered(res.signature_client);
          }
        } else {
          dispatch(warningErrorAction(t("Text_IncorrectData")));
        }
      } catch {
        if (mounted) dispatch(warningErrorAction(t("Text_IncorrectData")));
      }
      if (mounted) dispatch(setLoading(false));
    };
    if (id !== "0") fetchData();
    return () => { mounted = false; };
  }, [id, token, dispatch, t, showModalPurchasesSignatureSettings, drawSignatureCentered]);

  const handleSubmit = async () => {
    if (!formData.id) return;
    dispatch(setLoading(true));
    try {
      const res = await helpHttp().put(
        ENDPOINT,
        "purchasesignature/updatepurchasesignature",
        token,
        formData
      );
      if (res.status === "OK") {
        dispatch(successErrorAction(t("Text_SaveData")));
      } else {
        dispatch(warningErrorAction(t(res.cause)));
      }
    } catch {
      dispatch(warningErrorAction(t("Text_IncorrectData")));
    }
    dispatch(setLoading(false));
    handleClose();
  };

  if (!showModalPurchasesSignatureSettings) return null;

  return (
    <>
      {showModalPurchasesSignatureSettings ? ( 
        <div className="container-fluid email-send-wrapper">
          <Box sx={{ bgcolor: '#ffffff', width: '900px' }}>
            <form className="createform" onSubmit={handleClose}>  
              {/* HEADER */}
              <div className="formgeneral-card-header">
                <div className="formgeneral-header-content">
                  <div className="formgeneral-header-title2">
                    {isLoading ? (
                      <CircularProgress sx={{ color: "#f6c23e" }} />
                    ) : (
                      <>🖊 {t("Text_NumberPurchase_Sign")}: {formData.purchasenote}</>
                    )} 
                  </div>
                  <div className="email-card-actions">
                    {isLoading ? (
                      <CircularProgress sx={{ color : "#f6c23e"}}/>
                    ) : (
                      <>
                        <button
                          type="button"
                          className="formgeneral-send-btn"
                          onClick={handleSubmit}
                        >
                          {t('Button_Update')}
                        </button>
                        <button
                          type="button"
                          className="formgeneral-cancel-btn"
                          onClick={handleClose}
                        >
                          {t('Button_Cancel')}
                        </button>
                      </>
                    )} 
                  </div>
                </div>
              </div> 
              <br/>  
              {!isLoading ? (
                <>
                  <div className="signature-pdf">
                    {pdfUrl && (
                      <iframe
                        src={pdfUrl}
                        title="PDF Preview"
                        style={{ width: "100%", height: "600px", border: "none" }}
                      />
                    )}
                  </div> 
                </>
              ) : (
                <LoadingNews/>
              )} 
              <br/> 
              <div className="formdi-pending-card-flat">
                 <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: 4,
                    flexWrap: "wrap"
                  }}
                >
                  {/* FIRMA */}
                  <Box
                    sx={{
                      border: "2px solid #4e73df",
                      width: CLIENT_CANVAS_WIDTH,
                      height: CLIENT_CANVAS_HEIGHT
                    }}
                  >
                    <SignatureCanvas
                      penColor="black"
                      ref={canvasRef}
                      canvasProps={{
                        width: CLIENT_CANVAS_WIDTH,
                        height: CLIENT_CANVAS_HEIGHT,
                        style: {
                          width: `${CLIENT_CANVAS_WIDTH}px`,
                          height: `${CLIENT_CANVAS_HEIGHT}px`,
                          display: "block"
                        }
                      }}
                    />
                  </Box>

                  {/* BOTONES A LA DERECHA */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                      minWidth: 220
                    }}
                  >
                    <button
                      type="button"
                      className="purchase-action-btn formgeneral-btn-cancel"
                      onClick={handleClose}
                    >
                      {t("Button_Cancel_Sign")}
                    </button>
                    <button
                      type="button"
                      className="purchase-action-btn formgeneral-btn-delete"
                      onClick={handleDeleteSignature}
                    >
                      {t("Button_Delete_Sign")}
                    </button>
                    <button
                      type="button"
                      className="purchase-action-btn formgeneral-btn-insert"
                      onClick={handleSaveSignature}
                    >
                      {t("Button_View_Sign")}
                    </button>
                  </Box>
                </Box>
              </div>
              <br/>
            </form>
          </Box>
          {formData.id && (
            <ReportPurchaseSignature
              formPurchaseSignature={formData}
              setPdfBlob={setPdfBlob}
            />
          )}

          <br/>
        </div>
      ) : null}
    </>
  );    
};

PurchaseDeliverySign.propTypes = {
  id: PropTypes.string.isRequired,
  showModalPurchasesSignatureSettings: PropTypes.bool.isRequired
};

export default PurchaseDeliverySign;
